import api from './api';

export interface ContractorAuthData {
  email: string;
  name: string;
  phone?: string;
  password: string;
  jobToken?: string;
}

export interface ContractorInfo {
  _id: string;
  email: string;
  name: string;
  phone?: string;
  hasSubscription: boolean;
  subscriptionStatus: string;
}

export interface AuthResponse {
  success: boolean;
  message: string;
  token: string;
  contractor: ContractorInfo;
}

export const contractorAuthService = {
  // Register or login contractor
  async registerOrLogin(data: ContractorAuthData): Promise<AuthResponse> {
    const response = await api.post('/contractor-auth/register-or-login', data);
    return response.data;
  },

  // Verify contractor token
  async verifyToken(token: string): Promise<{ valid: boolean; contractor?: ContractorInfo }> {
    const response = await api.post('/contractor-auth/verify-token', { token });
    return response.data;
  },

  // Change password
  async changePassword(currentPassword: string | undefined, newPassword: string): Promise<void> {
    const response = await api.post('/contractor-auth/change-password', { currentPassword, newPassword });
    return response.data;
  },

  // Check if contractor exists by email
  async checkContractorExists(email: string): Promise<{ exists: boolean; hasPassword: boolean; contractor?: Partial<ContractorInfo> }> {
    const response = await api.get(`/contractor-auth/check/${email}`);
    return response.data;
  },

  // Store token in localStorage
  saveToken(token: string) {
    localStorage.setItem('contractor_token', token);
  },

  // Get token from localStorage
  getToken(): string | null {
    return localStorage.getItem('contractor_token');
  },

  // Remove token from localStorage
  clearToken() {
    localStorage.removeItem('contractor_token');
  },

  // Save contractor info to localStorage
  saveContractorInfo(contractor: ContractorInfo) {
    localStorage.setItem('contractor_info', JSON.stringify(contractor));
  },

  // Get contractor info from localStorage
  getContractorInfo(): ContractorInfo | null {
    const info = localStorage.getItem('contractor_info');
    return info ? JSON.parse(info) : null;
  },

  // Clear contractor info from localStorage
  clearContractorInfo() {
    localStorage.removeItem('contractor_info');
  },

  // Logout
  logout() {
    this.clearToken();
    this.clearContractorInfo();
    // Also clear any stale regular auth data
    localStorage.removeItem('user');
    localStorage.removeItem('agency');
    localStorage.removeItem('token');
  }
};
